import { render, staticRenderFns } from "./Trigger.vue?vue&type=template&id=04da8c4b&scoped=true&"
import script from "./Trigger.vue?vue&type=script&lang=js&"
export * from "./Trigger.vue?vue&type=script&lang=js&"
import style0 from "./Trigger.vue?vue&type=style&index=0&id=04da8c4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04da8c4b",
  null
  
)

export default component.exports